type StatusBadgeProps = {
  status: string;
};

const statusStyles: Record<string, string> = {
  已处理: "bg-accent-100 text-accent-900 border-accent-200",
  核查中: "bg-secondary-100 text-secondary-900 border-secondary-200",
  受理中: "bg-primary-100 text-primary-900 border-primary-200",
  已驳回: "bg-background-200 text-foreground-700 border-background-300",
};

const statusIcons: Record<string, string> = {
  已处理: "ri-checkbox-circle-line",
  核查中: "ri-search-eye-line",
  受理中: "ri-time-line",
  已驳回: "ri-close-circle-line",
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  const style = statusStyles[status] ?? "bg-background-200 text-foreground-700 border-background-300";
  const icon = statusIcons[status] ?? "ri-price-tag-3-line";

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-xs font-medium whitespace-nowrap ${style}`}
    >
      <i className={icon} aria-hidden="true"></i>
      {status}
    </span>
  );
}